import { IntegrationConfigSence } from 'models/integrations'
import api from '../..'

export const getConfig = () => {
  return api
    .get<IntegrationConfigSence>('integrations/sence/config')
    .then((response) => response.data)
}

export default getConfig
